/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="70.91" height="94.27" viewBox="0 0 70.91 94.27" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path d="M77.35,104H82.6a1,1,0,0,0,1-1,.76.76,0,0,0,0-.21l-3-13.11a1.11,1.11,0,0,1,0-.19.9.9,0,0,1,.41-.76,6.65,6.65,0,1,0-7,0,.91.91,0,0,1,.4.76.58.58,0,0,1,0,.19l-3,13.11a1.49,1.49,0,0,0,0,.21,1,1,0,0,0,1,1Z" transform="translate(-42 -30)" fill="#ffb81c" fillRule="evenodd"/><path d="M86.72,30A10.49,10.49,0,0,1,97.18,40.18V57.32a1.25,1.25,0,0,1-2.5.12v-17a8,8,0,0,0-7.72-8H68.19a8,8,0,0,0-8,7.72v5.13A1.25,1.25,0,0,1,59,46.6a1.27,1.27,0,0,1-1.25-1.13v-5A10.49,10.49,0,0,1,67.91,30H86.72Z" transform="translate(-42 -30)" fill="#0e497b"/><path d="M108.43,56.07H46.49A4.49,4.49,0,0,0,42,60.55v59.24a4.49,4.49,0,0,0,4.49,4.48h61.94a4.49,4.49,0,0,0,4.48-4.48V60.55A4.49,4.49,0,0,0,108.43,56.07Zm-61.94,2.5h61.94a2,2,0,0,1,2,2v59.24a2,2,0,0,1-2,2H46.49a2,2,0,0,1-2-2V60.55A2,2,0,0,1,46.49,58.57Z" transform="translate(-42 -30)" fill="#0e497b"/>
      </svg>

    );
  }
}

Icon.displayName = 'PadlockDisengagedIcon';

export default Icon;
